export default {"src":"/_next/static/media/twitch-ic.7e4eeded.svg","height":48,"width":48};